import React, { useEffect, useState } from 'react';
import '../../constants/styles/postSession.scss';

const PostSession = ({ setActivePanel }) => {
    const [surveyCompleted, setSurveyCompleted] = useState(false);

    useEffect(() => {
        if (surveyCompleted) {
            setTimeout(() => {
                window.location.href = 'https://www.cs.toronto.edu/~brli/summary-study/chatbot.html';
            }, 5000);
        }
    }, [surveyCompleted]);

    useEffect(() => {
        window.addEventListener('message', handleSurveyCompletion);
        return () => {
            window.removeEventListener('message', handleSurveyCompletion);
        };
    }, []);

    const handleSurveyCompletion = (event) => {
        if (event.data === 'surveyCompleted') {
            setSurveyCompleted(true);
        }
    };

    return (
        <div className='post-session-container'>
            {surveyCompleted ? (
                <div className="confirm-dialog-overlay">
                    <div className="confirm-dialog">
                        <h1>Thank you for your participation!</h1>
                        <p>The doctor will see you soon!</p>
                    </div>
                </div>
            ) : (true
//                <>
//                    <h1 className="intro">Post-Session Survey</h1>
//                    <div className='survey-panel'>
//                        <iframe
//                            src="https://rotman.az1.qualtrics.com/jfe/form/SV_3EsvsMR6iUzgckK"
//                            style={{ width: '100%', height: '500px', border: 'none' }}
//                            title="Post-Session Survey"
//                        ></iframe>
//                    </div>
 //               </>
            )}
        </div>
    );
};

export default PostSession;
